import React, {Component} from 'react';
import { useState } from 'react';
import { Link } from "react-router-dom";
import './side-menu.component.css'
function SideNav(props) {

        var navMenu = [
            {
              id:1,
              title: "Order Report",
              href: `/${props.urlType}/Reports/Order`            
            },
            {
              id:2,
              title: "Dispute Report",
              href: `/${props.urlType}/Reports/Dispute`
            },
            {
              id:3,
              title: "Inventory Report",
              href: "#", 
              subMenu: [
                {
                  subName: "Account Report",
                  href: `/${props.urlType}/Reports/Account`,   
                },
                {
                  subName: "Circuit Inventory",
                  href: `/${props.urlType}/Reports/Circuit-Inventory`,                     
                },
                {
                  subName: "HR Report",
                  href: `/${props.urlType}/Reports/HR`,       
                },
                
              ],  
            },
            {
              id:4,
              title: "Cost Report",
              href: "#", 
              subMenu: [
                {
                  subName: "Accrual Report",
                  href: `/${props.urlType}/Reports/Accrual`,   
                },
                {
                  subName: "Cost Report",
                  href: `/${props.urlType}/Reports/Cost-Report`,   
                },
                {
                  subName: "Expected Billing Report",
                  href: `/${props.urlType}/Reports/Expected-Billing-Report`,   
                },
                {
                  subName: "Cost Allocation Report",
                  href: `/${props.urlType}/Reports/Cost-Allocation-Report`,   
                },
                {
                  subName: "Invoice Report",
                  href: `/${props.urlType}/Reports/Invoice-Report`,   
                },
                {
                  subName: "Semi Annual Cost Report",
                  href: `/${props.urlType}/Reports/Semi-Annual-Report`,   
                },
                {
                  subName: "Invoice Calendar Report",
                  href: `/${props.urlType}/Reports/Invoice-Calendar-Report`,   
                },
                ,
                {
                  subName: "Spend Report",
                  href: `/${props.urlType}/Reports/Spend-Report`,   
                },
                ,
                {
                  subName: "High Spender Report",
                  href: `/${props.urlType}/Reports/High-Spender-Report`,   
                }
              ]
            }, 
            {
              id:5,
              title: "Usage Report",   
              href: "#", 
              subMenu:[
                {
                  subName: "Usage Report",
                  href: `/${props.urlType}/Reports/Usage-Report`,   
                },
                {
                  subName: "Calls By Type Report",
                  href: `/${props.urlType}/Reports/Calls-By-Type`,   
                }, 
                {
                  subName: "Rolling Trend Report",
                  href: `/${props.urlType}/Reports/Rolling-Trend-Report`,   
                },
                {
                  subName: "Telcom Vendor Payment Register",
                  href: `/${props.urlType}/Reports/Telcom-Vendor-Payment-Register`,   
                },
                {
                  subName: "MDUM Report",
                  href: `/${props.urlType}/Reports/MDUM-Report`,   
                },
                {
                  subName: "Zero Usage Report",
                  href: `/${props.urlType}/Reports/Zero-Usage-Report`,   
                },
              ]          
            }
          ];

          const [activeId,setActiveId]=useState(null);
          const toggleNav=(id,href)=>{
            if (href) {            
              window.location.href = href;
            } else {            
              setActiveId(activeId === id ? null : id);
            }
          }
        return(
            <div className={`side-nav-menu`}>
                <ul className="side-nav-main-menu">                   
                    {navMenu.map((item, id) => (
                        <li         
                            onClick={(e)=>{
                              e.preventDefault();
                              {
                                item.subMenu ?
                                toggleNav(item.id, item.subMenu.href)
                                :
                                toggleNav(item.id)
                              }
                              
                            }}                  
                            key={id}
                            className={`main-menu ${activeId===item.id ? "isActive" : " "}`}>                         
                             <div className={`side-nav-link-container ${activeId===item.id ? "isActive" : " "} ${typeof item.subMenu !== "undefined" && item.subMenu != null
                                    ? "has-side-nav-menu"
                                    : ""}`}>                                
                                <Link to={item.href}>{/*<Translation translationKey={item.title} />*/}{item.title}</Link>
                             </div>
                        <ul
                            className={
                                typeof item.subMenu !== "undefined" && item.subMenu != null
                                    ? "side-nav-sub-menu"
                                    : ""}>
                        {typeof item.subMenu !== "undefined" && item.subMenu != null
                            ? item.subMenu.map((subItem, subId) => (
                                <li                                  
                                    key={subId}
                                    className={`sub-list ${subItem.isActive ? "subSelected" : ""
                                        }`}>
                                    <Link className="side-nav-sub-link-container" to={subItem.href}>{/*<Translation translationKey={item.title} />*/}{subItem.subName}</Link>
                     
                                </li>
                            ))
                            : ""}
                            </ul>
                        </li>
                    ))}
                </ul>
            </div>
        );
}

export default SideNav;